module.exports = __webpack_public_path__ + "media/images/flags/4x3/kna-43bc298c05f52343652dbe231073db07.svg";